export enum FieldsMappingType {
  GENERIC,
  GOOGLE_SHEETS,
  INTERCOM_TAGS,
  KLAVIYO
}
